<template>
<!-- 车辆进行报价 -->
<div class="app-container">
    <!-- 查询区域 -->
    <div v-show="showSearch">
        <el-form :inline="true">
            <el-row>
                <el-form-item label="查询时间范围">
                    <el-date-picker
                        v-model="queryPara.bidDateRange"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="-"
                        unlink-panels
                        :picker-options="pickerOptionsBid"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>

                </el-form-item>

                <el-form-item label="登记时间范围">
                    <el-date-picker
                        v-model="queryPara.regDateRange"
                        type="daterange"
                        range-separator="-"
                        unlink-panels
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="逾期时间">
                    <el-date-picker
                        v-model="queryPara.bidEndTime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        default-time="12:00:00">
                    </el-date-picker>
                </el-form-item>
            </el-row>

            <el-row>
                <el-form-item label="报案号">
                    <el-input v-model="queryPara.caseSn" placeholder="请输入报案号" clearable></el-input>
                </el-form-item>
                <el-form-item label="车辆编号">
                    <el-input v-model="queryPara.vehicleSn" placeholder="请输入车辆编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="车牌号">
                    <el-input v-model="queryPara.current.plateNo" placeholder="请输入车牌号" clearable></el-input>
                </el-form-item>


                <el-form-item label="车架号">
                    <el-input v-model="queryPara.factory.vin" placeholder="请输入车架号"></el-input>
                </el-form-item>
            </el-row>

            <el-row>
                <el-form-item label="车辆型号:">

                    <el-autocomplete
                        v-model="queryPara.factory.vehicleTradeName"
                        :fetch-suggestions="querySearchModelName"
                        value-key="modelName"
                        placeholder="请输入车辆型号"
                        clearable
                        ></el-autocomplete>
                </el-form-item>
                <el-form-item label="保险公司">

                    <el-autocomplete
                        v-model="queryPara.insurance.insureCompany"
                        :fetch-suggestions="querySearchInsureCompany"
                        value-key="insureCompanyName"
                        placeholder="请输入保险公司"
                        clearable
                    ></el-autocomplete>
                    
                </el-form-item>

               

                <el-form-item label="区域">
                       
                       <el-select v-model="queryPara.check.district" placeholder="请选择区域" clearable>
                           <el-option
                               v-for="dict in dict.type.vehicle_district"
                               :key="dict.value"
                               :label="dict.label"
                               :value="dict.value"
                               />
                       </el-select>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="queryPara.userCollectFlag">已标记</el-checkbox>
                </el-form-item>
            </el-row>
            
          
            <el-form-item>
                <el-button size="mini" type="primary" icon="el-icon-refresh" @click="handleQuery">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh"   @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>
    </div>

    <!-- 按钮操作区域 -->
    <el-row :gutter="10" class="mb8">
     
      <el-col :span="1.5">
        <el-button
          type="info"
          plain
          icon="el-icon-sort"
          size="mini"
          @click="toggleExpandAll"
        >展开/折叠</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getListData"></right-toolbar>
    </el-row>
    
    <!-- 1 table区域 -->
    <el-table 
    :data="listData"
    :row-class-name="backgroundRowClassName"  
    v-if="refreshTable"
    @sort-change="sortChange"
    
    :default-expand-all="isExpandAll"
    v-loading="loading" element-loading-text="正在查询中...">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        
        <el-table-column label="级别" prop="check.vehicleLevelGrade" width="60">
        </el-table-column>
        
        <el-table-column label="事故类型" prop="check.vehicleLevel" width="60">
        </el-table-column>
        
        <el-table-column label="逾期时间" prop="bidEndTime" sortable="custom">
            <template v-slot="slotProps">
             
                {{parseTime(new Date(slotProps.row.bidEndTime).getTime()-intStopQuoteMinute*60*1000,'{y}-{m}-{d} {hh}:{i}:{ss}')}}
            </template>
        </el-table-column>
        <!--
        <el-table-column label="询价时间" prop="bidStartTime">
            <template v-slot="slotProps">
                {{parseTime(slotProps.row.bidStartTime,'{y}-{m}-{d}')}}
            </template> 
        </el-table-column>
        -->
        <el-table-column label="保险公司" prop="insurance.insureCompany">
        </el-table-column>

        <el-table-column label="车牌照号" prop="current.plateNo">
        </el-table-column>

        <el-table-column label="登记日期" prop="factory.registerDate" sortable="custom">
            <template v-slot="slotProps">
                {{parseTime(slotProps.row.factory.registerDate,'{y}-{m}-{d}')}}
            </template>
        </el-table-column>

        <el-table-column label="车辆型号" prop="factory.vehicleTradeName"></el-table-column>
        
        <el-table-column label="区域" prop="check.district">
            <template slot-scope="scope">
                <dict-tag :options="dict.type.vehicle_district" :value="scope.row.check.district"/>
            </template>
        </el-table-column>

        <el-table-column label="我的报价" sortable="custom" prop="quote.finalPrice"></el-table-column>

        <el-table-column label="操作">
            <template v-slot="slotProps">
                <el-button size="small" type="primary" @click="handleQuote(slotProps.row)">报价</el-button>
                
                <el-button size="mini" 
                v-show="slotProps.row.collect!='Y'"
                type="text"  @click="handleConfirmCollect(slotProps.row)">标记</el-button>

                <el-button size="mini" 
                type="text"  
                v-show="slotProps.row.collect=='Y'"
                @click="handleCancelCollect(slotProps.row)">取消标记</el-button>   
                
            </template>
        </el-table-column>

    </el-table>
    
    <!-- 分页区域 -->
    <pagination  v-show="totalRow>0" :total="totalRow" :page.sync="page.pageNumber" 
        :limit.sync="page.pageLimit" 
        @pagination="getListData">
    </pagination>
</div>

</template>
<script>
import {checkedQuoteListCase} from '@/api/vehicle/case'
import {confirmCollectCase,cancelCollectCase} from '@/api/vehicle/quote'
import {getVehileModelList} from '@/api/vehicleConfig/vehicleModel'
import {listInsurance} from '@/api/vehicleConfig/insurance'
import Pagination from '@/components/Pagination'
export default {
    name:'/vehicle-quote/list',
    components:{Pagination},
    dicts:['sys_yes_no','vehicle_district'],
data(){
    return{
        // 是否展开，默认全部展开
        isExpandAll: true,
        refreshTable:true,
        showSearch:true,//显示搜索
        loading : false,
        queryPara:{
            bidDateRange:[], //报价日期
            regDateRange:[], //注册日期
           
            vehicleSn:'',//车辆编号
            userCollectFlag:false,
            current:{
                plateNo:'',
            },
            factory:{
                vin:'',
            },
            insurance:{
                insuranceCompany:'',
            },
            check:{
                district:'',
            },

            orderSort:'ascending',
            columnName:'',
            
        },
        listData:[],
        intStopQuoteMinute:0,
        totalRow: 0,
        page: {
            pageNumber: 1,
            pageLimit: 10,
        },
        pickerOptionsBid:{
            shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 );
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近五天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 *5);
              picker.$emit('pick', [start, end]);
            }
          },
          ]
        },
        // 选择日期的快捷键
        pickerOptions: {
          shortcuts: [{
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 *  365);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近五年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365*5);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近十年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 *  365*10);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    }
},
created(){
    this.handleQuery();
},
methods:{
    toggleExpandAll() {
            this.refreshTable = false;
            this.isExpandAll = !this.isExpandAll;
            this.$nextTick(() => {
                this.refreshTable = true;
            });
    },
    // 收藏，标记颜色
    backgroundRowClassName({ row, rowIndex }){
        if (row.collect === 'Y') {
            return 'quote-collect-row' // 
        }
        return '' // 其他状态没有特殊类
    },
    handleReset(){
        
        
        this.queryPara={
                //保险公司部门
                caseSn:'',//报案号
                bidDateRange:[],//竞价时间范围
                regDateRange:[],
                bidEndTime:'', // 逾期时间
                vehicleSn:'',//车辆编号
                bidCompany:'', //中标公司
                userCollectFlag:false,
                // 保险公司信息
                insurance:{
                    insureCompany:'',//保险公司
                    insureFiliale:'',//保险分公司
                },
                
                //车辆信息
                
                current:{
                    plateNo:'',//车牌号
                },
               
                factory:{
                    vin:'',//车架号
                    vehicleTradeName:'',
                },
                regDateRange:[],//车辆登记日期
                queryPara:'',
              
                clientContact:'',
                check:{
                    isCheck:'',
                    vehicleLevel:'',
                    district:'',
                },
                caseStatus:'',//案件状态
                orderSort:'ascending',
                columnName:'',
        };
        
    },

    //查询
    handleQuery(){
        
        this.page.pageNumber=1;
        this.getListData();
    },

    sortChange({column,prop,order}){  
            column.multiOrder=order;
            
            if(column.sortable!=='custom'){
                return;
            }

            this.queryPara.orderSort=order;
            this.queryPara.columnName=prop;
            this.handleQuery();

    },
    getListData(){
       
        var para=Object.assign({},{page:this.page})
        this.loading = true;
        var para=Object.assign(this.queryPara,this.page)
        para=this.addDateRange(para,this.queryPara.bidDateRange,"bid")
        para=this.addDateRange(para,this.queryPara.regDateRange,"reg")
        checkedQuoteListCase(para).then(res=>{
            this.loading = false;
            this.totalRow=res.data.totalRow;
            this.listData=res.data.list;
            this.intStopQuoteMinute=res.stopQuoteMinute;
        })
    },
    //进行报价
    handleQuote(para){
      
        this.$router.push({ path: '/vehicle-quote/edit',query:{caseid: para.caseId}});
    },
    /**
         * 搜索车辆型号的名字
         */
    querySearchModelName(queryString, callback){
        var para={"modelName":queryString};
        getVehileModelList(para).then(res=>{
            callback(res.data);
        })
    },

    /**
     * 
     * @param queryString 
     * @param callback 
     */
    querySearchInsureCompany(queryString,callback){
        var para={"insureCompany":queryString};
        listInsurance(para).then(res=>{
            
            callback(res.data);
        })
    },

    //进行收藏
    handleConfirmCollect(row){
        
        this.$confirm('确定要收藏id为:'+row.caseId+';您确定要继续吗?', '提示', {  
            confirmButtonText: '确定',  
            cancelButtonText: '取消',  
            type: 'warning'  
        }).then(() => {  
            confirmCollectCase({"caseId":row.caseId,"collectFlag":'Y'}).then(res=>{
                if(res.success){
                    //收藏成功，把此row放入
                    row.collect="Y"
                }
            })
            .catch(error=>{

            })
        }); 
    },
    //取消收藏
    handleCancelCollect(row){
        this.$confirm('确定取消收藏id为:'+row.caseId+';您确定要继续吗?', '提示', {  
            confirmButtonText: '确定',  
            cancelButtonText: '取消',  
            type: 'warning'  
        }).then(() => {  
            cancelCollectCase({"caseId":row.caseId,"collectFlag":'N'}).then(res=>{
                if(res.success){
                    row.collect="N"
                }
            })
            .catch(error=>{

            })
        }); 
    },



}
}
</script>
<style >
    .wrapper{
		margin-left: 5%;
		margin-right: 5%;
	}

    .app-container .quote-collect-row{
        background:burlywood !important; /* 浅黄色背景 */
        
        /* background: #1890ff !important;  */
      
    }
   
  
</style>